import { type ReactNode } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';

/**
 * Envuelve el contenido de un paso del flujo de reserva y anima su ENTRADA cada
 * vez que cambia `stepKey`. Solo animación de entrada (el spinner de carga entre
 * acciones interrumpiría cualquier salida, así que no la intentamos): el contenido
 * "se asienta" al llegar. Respeta prefers-reduced-motion.
 *
 * Es puramente presentacional: no toca estado ni lógica de reserva.
 */
export function StepTransition({
  stepKey,
  children,
}: {
  stepKey: string;
  children: ReactNode;
}) {
  const reduceMotion = useReducedMotion();

  return (
    <AnimatePresence mode="wait" initial={false}>
      <motion.div
        key={stepKey}
        initial={
          reduceMotion
            ? { opacity: 0 }
            : { opacity: 0, y: 12, scale: 0.985 }
        }
        animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={
          reduceMotion
            ? { duration: 0.2, ease: 'linear' }
            : { duration: 0.42, ease: [0.22, 1, 0.36, 1] }
        }
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
}
